import {combineReducers} from 'redux';
import adminReducer from './adminReducer';
import adminTokenReducer  from './adminTokenReducer';
const reducers= combineReducers({
    adminToken: adminTokenReducer,
    admin:adminReducer,
})

export default reducers;